import { Text } from '@backstage/ui';
import {
  configApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import type { ProfileInfo } from '@backstage/core-plugin-api';
import { useState, useEffect } from 'react';

export const WelcomeBanner = () => {
  const api = useApi(identityApiRef);
  const appTitle =
    useApi(configApiRef).getOptionalString('app.title') ?? 'Backstage';
  const [profileState, setProfileState] = useState<ProfileInfo>({});

  useEffect(() => {
    api.getProfileInfo().then(profileValue => {
      setProfileState(profileValue);
    });
  }, [api]);

  // Keep the Home browser-tab title while this page is mounted.
  useEffect(() => {
    const previous = document.title;
    document.title = `Home | ${appTitle}`;
    return () => {
      document.title = previous;
    };
  }, [appTitle]);

  const headerTitle = `Welcome to Backstage, ${profileState.displayName}!`;

  return (
    <Text as="h1" variant="title-small" weight="bold">
      {headerTitle}
    </Text>
  );
};
